import {differenceInDays, parseISO, startOfToday} from "date-fns";

import {Text} from "@pg-design/text-module";
import {Country, OfferType} from "@pg-rp/common-types";

import {IOffer} from "../../types/property/IOffer";
import {getOfferGenericDescription} from "../../utils/get_offer_generic_description";
import {OfferGeneratedDescriptionCommercial} from "../offer_generated_description/OfferGeneratedDescriptionCommercial";
import {OfferGeneratedDescriptionFlat} from "../offer_generated_description/OfferGeneratedDescriptionFlat";
import {OfferGeneratedDescriptionHouse} from "../offer_generated_description/OfferGeneratedDescriptionHouse";

interface IProps {
    offer: IOffer;
    region: {
        country: Country;
        name_declension_where: string;
    };
    type: OfferType;
}

export const HomematchPropertyCardDetailOfferInfoDescriptionGenerated = (props: IProps) => {
    const {offer, region, type} = props;

    const constructionEndDate = offer.construction_date_range?.upper && parseISO(offer.construction_date_range.upper);
    const constructionDateDiffDays = differenceInDays(startOfToday(), constructionEndDate);
    const genericDescription = getOfferGenericDescription(offer, region.name_declension_where, constructionDateDiffDays);

    return (
        <Text as="div" variant="body_copy_1">
            <p>{genericDescription}</p>

            {type === OfferType.COMMERCIAL && <OfferGeneratedDescriptionCommercial country={region.country} offer={offer} />}
            {type === OfferType.FLAT && <OfferGeneratedDescriptionFlat country={region.country} offer={offer} type={type} />}
            {type === OfferType.HOUSE && <OfferGeneratedDescriptionHouse country={region.country} offer={offer} type={type} />}
        </Text>
    );
};
import {differenceInDays, parseISO, startOfToday} from "date-fns";

import {Text} from "@pg-design/text-module";
import {Country, OfferType} from "@pg-rp/common-types";

import {IOffer} from "../../types/property/IOffer";
import {getOfferGenericDescription} from "../../utils/get_offer_generic_description";
import {OfferGeneratedDescriptionCommercial} from "../offer_generated_description/OfferGeneratedDescriptionCommercial";
import {OfferGeneratedDescriptionFlat} from "../offer_generated_description/OfferGeneratedDescriptionFlat";
import {OfferGeneratedDescriptionHouse} from "../offer_generated_description/OfferGeneratedDescriptionHouse";

interface IProps {
    offer: IOffer;
    region: {
        country: Country;
        name_declension_where: string;
    };
    type: OfferType;
}

export const HomematchPropertyCardDetailOfferInfoDescriptionGenerated = (props: IProps) => {
    const {offer, region, type} = props;

    const constructionEndDate = offer.construction_date_range?.upper && parseISO(offer.construction_date_range.upper);
    const constructionDateDiffDays = differenceInDays(startOfToday(), constructionEndDate);
    const genericDescription = getOfferGenericDescription(offer, region.name_declension_where, constructionDateDiffDays);

    return (
        <Text as="div" variant="body_copy_1">
            <p>{genericDescription}</p>

            {type === OfferType.COMMERCIAL && <OfferGeneratedDescriptionCommercial country={region.country} offer={offer} />}
            {type === OfferType.FLAT && <OfferGeneratedDescriptionFlat country={region.country} offer={offer} type={type} />}
            {type === OfferType.HOUSE && <OfferGeneratedDescriptionHouse country={region.country} offer={offer} type={type} />}
        </Text>
    );
};
